import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { MenuGroupContext } from '../useMenuGroupContext';
import type { MenuGroupProps } from './types';

const MenuGroup = ({ children, label = '', isMulti = false, name, hideSelectedIndicator = false }: MenuGroupProps) => (
  <MenuGroupContext.Provider value={{ isMulti, name, hideSelectedIndicator }}>
    <Container>
      {label && (
        <Box
          color="grey_800"
          fontSize="b_xs"
          marginTop="2"
          marginBottom="1.5"
          marginX="4"
          lineHeight="b_xs"
          fontWeight="semibold"
        >
          {label}
        </Box>
      )}
      {children}
    </Container>
  </MenuGroupContext.Provider>
);

MenuGroup.id = 'MenuGroup';
MenuGroup.displayName = 'MenuGroup';

export default MenuGroup;
